module.exports = __webpack_public_path__ + "static/img/03.f97e9be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/03.jpg
// module id = 377
// module chunks = 1